// promo-cards.js
// Part 1 — render live promo product cards from checkout_rules metafield.
// Part 2 — intercept Add to basket to use the cart drawer (existing behaviour).

(function () {
  var rulesEl = document.getElementById('promo-checkout-rules');
  if (!rulesEl) return;

  var rules;
  try { rules = JSON.parse(rulesEl.textContent); } catch (e) { return; }

  Object.keys(rules).forEach(function (promoName) {
    var rule = rules[promoName];
    var discounts = (rule.preview_discounts || []).filter(function (pd) {
      return pd.handle && pd.variant_id;
    });
    if (!discounts.length) return;

    var container = document.querySelector(
      '.promo-product-cards[data-promo-name="' + promoName.replace(/"/g, '\\"') + '"]'
    );
    if (!container) return;

    // Fetch each product by handle, then find the exact variant.
    var fetches = discounts.map(function (pd) {
      return fetch('/products/' + pd.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var variant = (product.variants || []).find(function (v) {
            return v.id === pd.variant_id;
          });
          if (!variant) return null;

          var origCents = variant.price; // Shopify AJAX API returns pence
          var discCents;
          var t = (pd.type || '').toLowerCase();
          if (t === 'pct' || t === 'percentage' || t === '%') {
            discCents = Math.round(origCents * (1 - pd.value / 100));
          } else {
            discCents = Math.max(0, origCents - Math.round(pd.value * 100));
          }

          var img = variant.featured_image
            ? variant.featured_image.src
            : (product.featured_image || '');
          // Request a small image size from Shopify CDN
          if (img) img = img.replace(/(\.[^.?]+)(\?.*)?$/, '_120x120$1$2');

          return {
            variantId: variant.id,
            title: product.title,
            img: img,
            imgAlt: (variant.featured_image && variant.featured_image.alt) || product.title,
            origCents: origCents,
            discCents: discCents,
          };
        })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (results) {
      results.forEach(function (r) {
        if (!r) return;
        container.insertAdjacentHTML('beforeend', buildCard(r));
      });
    });
  });

  function fmt(cents) {
    return '£' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildCard(r) {
    var imgHtml = r.img
      ? '<img class="promo-product-card__img" src="' + esc(r.img) + '" alt="' + esc(r.imgAlt) + '">'
      : '';

    var priceHtml;
    if (r.discCents < r.origCents) {
      priceHtml =
        '<div class="promo-product-card__prices">' +
        '<span class="promo-product-card__price promo-product-card__price--original">' + fmt(r.origCents) + '</span>' +
        '<span class="promo-product-card__price promo-product-card__price--discounted">' + fmt(r.discCents) + '</span>' +
        '</div>';
    } else {
      priceHtml = '<span class="promo-product-card__price">' + fmt(r.origCents) + '</span>';
    }

    return (
      '<div class="promo-product-card">' +
        imgHtml +
        '<div class="promo-product-card__info">' +
          '<span class="promo-product-card__title">' + esc(r.title) + '</span>' +
          priceHtml +
        '</div>' +
        '<form class="promo-product-card__form">' +
          '<input type="hidden" name="id" value="' + r.variantId + '">' +
          '<input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="promo-product-card__btn">Add to basket</button>' +
        '</form>' +
      '</div>'
    );
  }
})();

// Part 2 — intercept Add to basket to use the slide-in cart drawer.
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form.classList.contains('promo-product-card__form')) return;
  e.preventDefault();

  var variantId = form.querySelector('[name="id"]').value;
  var btn = form.querySelector('.promo-product-card__btn');
  var originalText = btn.textContent;

  btn.disabled = true;
  btn.textContent = 'Adding…';

  var cartDrawer = document.querySelector('cart-drawer');

  var body = JSON.stringify({
    id: parseInt(variantId, 10),
    quantity: 1,
    sections: cartDrawer
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : [],
    sections_url: window.location.pathname,
  });

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: body,
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        btn.textContent = 'Error';
      } else {
        btn.textContent = 'Added!';
        if (cartDrawer) cartDrawer.renderContents(data);
      }
      setTimeout(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      }, 2000);
    })
    .catch(function () {
      btn.textContent = 'Error';
      setTimeout(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      }, 2000);
    });
});
